import axios from "@/api/axiosInstance";
import {
  DataEnvelope,
  Enrollment,
} from "@/modules/learningCenter/features/CourseDirectory/types/viewer";

// Reset a module to incomplete for the caller's own active enrollment. Returns
// the recomputed enrollment (progress + status).
export const resetModule = async (moduleUuid: string): Promise<Enrollment> => {
  const response = await axios.post<DataEnvelope<Enrollment>>(
    `/api/private/learning-center/modules/${moduleUuid}/reset`,
  );
  return response.data.data;
};
